import { useEffect, useRef, useState } from "react";
import { Axios } from "../../../Api/axios";
import {
  ADMIN_ALL_CLASSES,
  ADMIN_ALL_SUBJECTS,
  ADMIN_NEW_INTENSIVE,
} from "../../../Api/Api";
import LoadingSubmit from "../../../Components/Loading/Loading";
import { useNavigate } from "react-router-dom";
import DashDialog from "../../../Components/Dashboard/DashDialog";
import DashSelect from "../../../Components/Dashboard/DashSelect";
import "./AddIntensive.css";

const DAYS  = ["السبت", "الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة"];
const UNITS = ["يوم", "أسبوع", "شهر"];

export default function AddIntensive() {
  const nav = useNavigate();

  const [classes,  setClasses]  = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [loading,  setLoading]  = useState(false);

  const [classId,       setClassId]       = useState("");
  const [subjectMode,   setSubjectMode]   = useState("existing");
  const [subjectId,     setSubjectId]     = useState("");
  const [subjectCustom, setSubjectCustom] = useState("");
  const [teacherName,   setTeacherName]   = useState("");
  const [startDate,     setStartDate]     = useState("");
  const [durationValue, setDurationValue] = useState("");
  const [durationUnit,  setDurationUnit]  = useState("شهر");
  const [schedule,      setSchedule]      = useState({});
  const [photo,         setPhoto]         = useState(null);
  const [photoPreview,  setPhotoPreview]  = useState(null);

  const nameRef = useRef(null);
  const fileRef = useRef(null);
  useEffect(() => { nameRef.current?.focus(); }, []);

  useEffect(() => {
    Axios.get(ADMIN_ALL_CLASSES).then((r) => setClasses(r.data.classes || [])).catch(() => {});
    Axios.get(ADMIN_ALL_SUBJECTS).then((r) => setSubjects(r.data.subjects || [])).catch(() => {});
  }, []);

  function toggleDay(day) {
    setSchedule((prev) => {
      const next = { ...prev };
      if (day in next) delete next[day];
      else next[day] = { time: "09:00", hours: "" };
      return next;
    });
  }
  function setDayField(day, field, value) {
    setSchedule((prev) => ({ ...prev, [day]: { ...prev[day], [field]: value } }));
  }

  function handlePhoto(e) {
    const f = e.target.files[0];
    if (!f) return;
    setPhoto(f);
    setPhotoPreview(URL.createObjectURL(f));
  }
  function removePhoto() {
    setPhoto(null);
    setPhotoPreview(null);
    if (fileRef.current) fileRef.current.value = "";
  }

  const subjectOk = subjectMode === "existing" ? !!subjectId : subjectCustom.trim().length >= 2;
  const isValid   = teacherName.trim().length >= 2 && subjectOk;

  async function handleSubmit() {
    if (!isValid) return;
    setLoading(true);
    const scheduleArr = DAYS
      .filter((d) => d in schedule)
      .map((d) => ({ day: d, time: schedule[d].time, hours: schedule[d].hours || null }));
    const fd = new FormData();
    fd.append("name", teacherName.trim());
    if (classId)                                       fd.append("class_id",       classId);
    if (subjectMode === "existing" && subjectId)       fd.append("subject_id",     subjectId);
    if (subjectMode === "custom")                      fd.append("subject_custom", subjectCustom.trim());
    if (startDate)                                     fd.append("start_date",     startDate);
    if (durationValue)                                 fd.append("duration_value", durationValue);
    fd.append("duration_unit", durationUnit);
    if (scheduleArr.length > 0) fd.append("times", JSON.stringify(scheduleArr));
    if (photo)                  fd.append("photo", photo);
    try {
      await Axios.post(ADMIN_NEW_INTENSIVE, fd);
      nav("/dashboard/T_Intensive");
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }

  const activeDays = DAYS.filter((d) => d in schedule).length;

  return (
    <>
      {loading && <LoadingSubmit />}
      <DashDialog
        title="إضافة دورة مكثفة جديدة"
        onSubmit={handleSubmit}
        submitDisabled={!isValid || loading}
        submitLabel={loading ? "جاري الحفظ..." : "حفظ الدورة"}
      >

        {/* ══ Section: معلومات الدورة ══ */}
        <div className="ai-section">
          <div className="ai-section-title">
            <svg width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>
            </svg>
            معلومات الدورة
          </div>

          {/* Class */}
          <div className="ai-field">
            <label className="ai-label">
              <svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24" className="ai-label-icon">
                <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>
              </svg>
              الصف
              <span className="ai-optional">(اختياري)</span>
            </label>
            <DashSelect
              value={classId}
              onChange={setClassId}
              options={[
                { value: "", label: "بدون صف محدد" },
                ...classes.map((c) => ({ value: c.id, label: c.name })),
              ]}
              icon={
                <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>
                </svg>
              }
            />
          </div>

          {/* Subject */}
          <div className="ai-field">
            <label className="ai-label">
              <svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24" className="ai-label-icon">
                <path d="M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-2 14H8v-2h8v2zm0-4H8v-2h8v2zm0-4H8V6h8v2z"/>
              </svg>
              المادة
            </label>
            <div className="ai-toggle-row">
              <button
                type="button"
                className={`ai-toggle-btn${subjectMode === "existing" ? " active" : ""}`}
                onClick={() => setSubjectMode("existing")}
              >
                <svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>
                </svg>
                من مواد المعهد
              </button>
              <button
                type="button"
                className={`ai-toggle-btn${subjectMode === "custom" ? " active" : ""}`}
                onClick={() => setSubjectMode("custom")}
              >
                <svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                </svg>
                مادة أخرى
              </button>
            </div>
            {subjectMode === "existing" ? (
              <DashSelect
                value={subjectId}
                onChange={setSubjectId}
                options={[
                  { value: "", label: "اختر المادة..." },
                  ...subjects.map((s) => ({ value: s.id, label: s.name })),
                ]}
                icon={
                  <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-2 14H8v-2h8v2zm0-4H8v-2h8v2zm0-4H8V6h8v2z"/>
                  </svg>
                }
              />
            ) : (
              <div className="ai-input-wrap">
                <input
                  className="ai-input"
                  type="text"
                  placeholder="اسم المادة..."
                  value={subjectCustom}
                  onChange={(e) => setSubjectCustom(e.target.value)}
                />
              </div>
            )}
          </div>

          {/* Teacher */}
          <div className="ai-field">
            <label className="ai-label" htmlFor="ai-teacher">
              <svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24" className="ai-label-icon">
                <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/>
              </svg>
              أستاذ الدورة
            </label>
            <div className="ai-input-wrap">
              <input
                id="ai-teacher"
                ref={nameRef}
                className="ai-input"
                type="text"
                placeholder="اسم الأستاذ..."
                value={teacherName}
                onChange={(e) => setTeacherName(e.target.value)}
                required
              />
            </div>
          </div>
        </div>

        {/* ══ Section: التوقيت ══ */}
        <div className="ai-section">
          <div className="ai-section-title">
            <svg width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
              <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/>
            </svg>
            التوقيت
          </div>

          <div className="ai-two-col">
            {/* Start date */}
            <div className="ai-field">
              <label className="ai-label" htmlFor="ai-date">
                <svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24" className="ai-label-icon">
                  <path d="M20 3h-1V1h-2v2H7V1H5v2H4C2.9 3 2 3.9 2 5v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"/>
                </svg>
                تاريخ البدء
                <span className="ai-optional">(اختياري)</span>
              </label>
              <div className="ai-input-wrap">
                <input
                  id="ai-date"
                  className="ai-input"
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  min={new Date().toISOString().slice(0, 10)}
                />
              </div>
            </div>

            {/* Duration */}
            <div className="ai-field">
              <label className="ai-label">
                <svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24" className="ai-label-icon">
                  <path d="M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A7.93 7.93 0 0 0 12 4c-4.42 0-8 3.58-8 8s3.57 8 8 8 8-3.58 8-8c0-1.82-.62-3.5-1.65-4.84zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"/>
                </svg>
                المدة
                <span className="ai-optional">(اختياري)</span>
              </label>
              <div className="ai-duration-row">
                <div className="ai-input-wrap ai-duration-num">
                  <input
                    className="ai-input"
                    type="number"
                    min="1"
                    placeholder="العدد"
                    value={durationValue}
                    onChange={(e) => setDurationValue(e.target.value)}
                  />
                </div>
                <div className="ai-unit-group">
                  {UNITS.map((u) => (
                    <button
                      key={u}
                      type="button"
                      className={`ai-unit-btn${durationUnit === u ? " active" : ""}`}
                      onClick={() => setDurationUnit(u)}
                    >
                      {u}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ══ Section: الجدول الأسبوعي ══ */}
        <div className="ai-section">
          <div className="ai-section-title">
            <svg width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5C3.89 3 3.01 3.9 3.01 5L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"/>
            </svg>
            الجدول الأسبوعي
            <span className="ai-optional">(اختياري)</span>
            {activeDays > 0 && (
              <span className="ai-day-count">{activeDays} يوم</span>
            )}
          </div>
          <div className="ai-days-grid">
            {DAYS.map((day) => {
              const on = day in schedule;
              return (
                <div key={day} className={`ai-day-row${on ? " ai-day-row--on" : ""}`}>
                  <label className="ai-day-check">
                    <input
                      type="checkbox"
                      checked={on}
                      onChange={() => toggleDay(day)}
                    />
                    <span className="ai-day-label">{day}</span>
                  </label>
                  {on && (
                    <>
                      <input
                        type="time"
                        className="ai-time-input"
                        value={schedule[day].time}
                        onChange={(e) => setDayField(day, "time", e.target.value)}
                      />
                      <div className="ai-hours-wrap">
                        <input
                          type="number"
                          className="ai-hours-input"
                          min="1" max="12"
                          placeholder="—"
                          value={schedule[day].hours}
                          onChange={(e) => setDayField(day, "hours", e.target.value)}
                        />
                        <span className="ai-hours-label">ساعة</span>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* ══ Section: صورة الدورة ══ */}
        <div className="ai-section ai-section-last">
          <div className="ai-section-title">
            <svg width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
              <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
            </svg>
            صورة الدورة
            <span className="ai-optional">(اختياري)</span>
          </div>
          <input
            ref={fileRef}
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={handlePhoto}
          />
          {photoPreview ? (
            <div className="ai-photo-preview">
              <img src={photoPreview} alt="صورة الدورة" className="ai-photo-img" />
              <div className="ai-photo-info">
                <span className="ai-photo-name">{photo?.name}</span>
                <span className="ai-photo-size">
                  {photo && photo.size < 900 * 1024
                    ? (photo.size / 1024).toFixed(0) + " KB"
                    : photo && (photo.size / (1024 * 1024)).toFixed(1) + " MB"}
                </span>
                <div className="ai-photo-actions">
                  <button type="button" className="ai-photo-change" onClick={() => fileRef.current?.click()}>تغيير</button>
                  <button type="button" className="ai-photo-remove" onClick={removePhoto}>حذف</button>
                </div>
              </div>
            </div>
          ) : (
            <button type="button" className="ai-upload-zone" onClick={() => fileRef.current?.click()}>
              <div className="ai-upload-icon">
                <svg width="26" height="26" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
                </svg>
              </div>
              <p className="ai-upload-hint">اضغط لرفع صورة الدورة</p>
              <p className="ai-upload-sub">PNG، JPG، WEBP — حتى 5 ميغابايت</p>
            </button>
          )}
        </div>

      </DashDialog>
    </>
  );
}
